import { ConfigProvider } from 'antd';
import React from 'react';
import { IntlProvider, addLocaleData } from 'react-intl';
import { connect } from 'react-redux';
import {locale as english} from 'src/locales/en-US';

addLocaleData(english.localeData);

const locales = {
  'en-US': english,
};

interface Settings {
  locale: keyof typeof locales;
}

interface LocalizationProps {
  children: React.ReactNode;
  settings: Settings;
}
class LocaleComponent extends React.Component<LocalizationProps> {
  render() {
    const {
      children,
      settings: { locale },
    } = this.props;
    const currentLocale = locales[locale];
    return (
      <ConfigProvider locale={currentLocale.antdData}>
        <IntlProvider locale={currentLocale.locale} messages={currentLocale.messages}>
          {children}
        </IntlProvider>
      </ConfigProvider>
    );
  }
}

export const Localization = connect(({ settings }: { settings: Settings }) => ({ settings }))(
  LocaleComponent,
);
